var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6006 2.98529C18.1084 2.98529 22.6006 7.47748 22.6006 12.9853C22.6006 18.5322 18.1084 22.9853 12.6006 22.9853C7.05371 22.9853 2.60059 18.5322 2.60059 12.9853C2.60059 10.2119 3.7334 7.67279 5.56934 5.87592C6.07715 5.3681 6.8584 5.3681 7.36621 5.87592C7.83496 6.38373 7.83496 7.16498 7.32715 7.63373C5.95996 9.00092 5.10059 10.915 5.10059 12.9853C5.10059 17.1259 8.45996 20.4853 12.6006 20.4853C16.7412 20.4853 20.1006 17.1259 20.1006 12.9853C20.1006 9.27435 17.3662 6.18842 13.8506 5.60248V6.73529C13.8506 7.43842 13.2646 7.98529 12.6006 7.98529C11.8975 7.98529 11.3506 7.43842 11.3506 6.73529V4.23529C11.3506 3.57123 11.8975 2.98529 12.6006 2.98529ZM10.1396 9.19623L13.2646 12.3212C13.6162 12.7119 13.6162 13.2978 13.2646 13.6494C12.874 14.04 12.2881 14.04 11.9365 13.6494L8.81152 10.5244C8.4209 10.1728 8.4209 9.58685 8.81152 9.19623C9.16309 8.84467 9.74902 8.84467 10.1396 9.19623Z",
    fill: "#407097"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.8ba3d3864e5ea02192641071c115d030.svg";
export { ForwardRef as ReactComponent };